import React, { useState } from "react";
import {
  BaseBox,
  BaseTypography,
  BaseTextField,
  BaseButton,
  BasePre,
} from "../../../Common/UI/exports";
import {
  retrieveSecrets,
  createSecret,
  updateSecret,
  rollbackSecret,
} from "../../../APIs/AwsSecretsManager";

function AwsSecretsManager() {
  const email = localStorage.getItem("email");

  const [secretName, setSecretName] = useState("");
  const [secretValue, setSecretValue] = useState("");
  const [response, setResponse] = useState(null);

  const handleAction = async (action) => {
    try {
      let data;

      const parsedValue =
        secretValue && secretValue.trim() !== "" ? JSON.parse(secretValue) : {};

      switch (action) {
        case "create":
          data = await createSecret(secretName, parsedValue);
          break;
        case "update":
          data = await updateSecret(secretName, parsedValue);
          break;
        case "get":
          data = await retrieveSecrets(secretName);
          break;
        case "rollback":
          data = await rollbackSecret(secretName);
          break;
        case "clear_response":
          data = null;
          break;
        default:
          return;
      }

      setResponse(data);
    } catch (err) {
      console.error(err);
      setResponse({
        error: err.response?.data || err.message,
      });
    }
  };

  return (
      <BaseBox
        sx={{
          height: "calc(100vh - 140px)",
          display: "flex",
          flexDirection: "column",
          maxWidth: "1160px",
          mx: "auto",
          mt: 0,
          px: 2,
        }}
      >
        <BaseTypography sx={{ fontSize: "1.2rem", mb: 0, fontWeight: 600 }}>
          AWS Secrets Manager
        </BaseTypography>

        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <BaseTextField
            label="Secret Name"
            placeholder="Enter secret name"
            value={secretName}
            onChange={(e) => setSecretName(e.target.value)}
            fullWidth={false}
            sx={{ width: "20%" }}
          />

          <BaseTextField
            label="Secret Data"
            value={secretValue}
            onChange={(e) => setSecretValue(e.target.value)}
            fullWidth
            multiline
            rows={8}
          />

          {/* Buttons below table */}
          <BaseBox sx={{ display: "flex", gap: 2, mt: 2 }}>
            <BaseButton
              onClick={() => handleAction("clear_response")}
              color="info"
            >
              Clear Response
            </BaseButton>
            <BaseButton onClick={() => handleAction("get")} color="secondary">
              Get
            </BaseButton>
            <BaseButton
              onClick={() => handleAction("rollback")}
              color="secondary"
            >
              Rollback
            </BaseButton>
            <BaseButton onClick={() => handleAction("update")} color="primary">
              Update
            </BaseButton>
            <BaseButton onClick={() => handleAction("create")} color="primary">
              Create
            </BaseButton>
          </BaseBox>
        </BaseBox>

        <BaseBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <BaseTextField
            label="Response"
            value={response ? JSON.stringify(response, null, 2) : ""}
            fullWidth
            multiline
            rows={8}
          />
        </BaseBox>
      </BaseBox>
  );
}

export default AwsSecretsManager;
